import React from "react";
import { Accordion } from "@mantine/core";

/** Render backend HTML (assumed sanitized) */
function HtmlContent({ value }) {
  if (!value) return <em className="text-gray-500">Not provided</em>;
  if (typeof value === "string") return <div dangerouslySetInnerHTML={{ __html: value }} />;
  if (value && typeof value === "object" && "__html" in value) return <div dangerouslySetInnerHTML={value} />;
  return <span>{String(value)}</span>;
}

const CollapsibleItem = ({ label, children, classNames }) => (
  <Accordion.Item
    value={label}
    className={`rounded-lg border border-gray-200 bg-white shadow-sm ${classNames?.item || ""}`}
  >
    {/* Compact, professional header */}
    <Accordion.Control
      className={`font-MTNfont text-gray-900 py-2 px-4 text-sm leading-5 min-h-0 hover:bg-gray-50 ${classNames?.control || ""}`}
      chevronPosition="right"
    >
      {label}
    </Accordion.Control>

    {/* Polished body: good line-height, subtle spacing; inner scroll for very long sections */}
    <Accordion.Panel className={`py-3 px-4 ${classNames?.panel || ""}`}>
      <div className="max-w-none text-gray-800 text-[0.95rem] leading-7 space-y-3 max-h-[420px] overflow-auto">
        <HtmlContent value={children} />
      </div>
    </Accordion.Panel>
  </Accordion.Item>
);

export default CollapsibleItem;
